import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import edit from 'src/assets/images/Edit.svg';
import RowContainerRPDesktop from './RowContainerRPDesktop';
import { useTranslation } from 'react-i18next';
import NoItemTableData from 'src/pages/reportUsage/common/NoData';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: '15px 0px 15px 0px',
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));
const ItemsListRPContainerDesktop = (props) => {
    const {
        toggleHidePricesBtn,
        selectedChildEditItem,
        selectedChildItem,
        selectedChildIndex,
        onAccountOwnedSeleted,
        deleteItem,
        editItem,
        editChildItem,
        editedChildItemList,
        addSerialNumber,
        editedItemList,
        lotSerialValueEntered,
        showBundlefromTableList,
        isBundleExpanded,
        setIsBundleExpanded,
        reportUsageFormObj,
        isFromReportScreen,
        checkboxReportPaymentClickHandler,
        reportPaymentGridData,
        setReportPaymentGridData,
        selectedCheckBox,
        checkBoxSelectedIndex,
        deletePO,
        winWidth,
        onImagePreview,
        myCaseResourceType,
        vendorCaseErrorRedirection,
        onIsSerialUnknown,
    } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <React.Fragment>
            {reportPaymentGridData?.length !== 0 ? (
                <>
                    {reportPaymentGridData &&
                        reportPaymentGridData &&
                        reportPaymentGridData.map((item, index) => {
                            return (
                                <>
                                    <RowContainerRPDesktop
                                        key={`${item.productCFN} ${index}`}
                                        classes={classes}
                                        item={item}
                                        index={index}
                                        edit={edit}
                                        editItem={editItem}
                                        editedItemList={editedItemList}
                                        addSerialNumber={addSerialNumber}
                                        lotSerialValueEntered={
                                            lotSerialValueEntered
                                        }
                                        onAccountOwnedSeleted={
                                            onAccountOwnedSeleted
                                        }
                                        deleteItem={deleteItem}
                                        displayPrice={
                                            toggleHidePricesBtn === 'hideBtn'
                                        }
                                        showBundlefromTableList={
                                            showBundlefromTableList
                                        }
                                        editChildItem={editChildItem}
                                        selectedChildItem={selectedChildItem}
                                        selectedChildEditItem={
                                            selectedChildEditItem
                                        }
                                        selectedChildIndex={selectedChildIndex}
                                        editedChildItemList={
                                            editedChildItemList
                                        }
                                        isBundleExpanded={isBundleExpanded}
                                        setIsBundleExpanded={
                                            setIsBundleExpanded
                                        }
                                        isFromReportScreen={isFromReportScreen}
                                        checkboxReportPaymentClickHandler={
                                            checkboxReportPaymentClickHandler
                                        }
                                        reportPaymentGridData={
                                            reportPaymentGridData
                                        }
                                        setReportPaymentGridData={
                                            setReportPaymentGridData
                                        }
                                        selectedCheckBox={selectedCheckBox}
                                        checkBoxSelectedIndex={
                                            checkBoxSelectedIndex
                                        }
                                        reportUsageFormObj={reportUsageFormObj}
                                        checkNewAddedProduct={
                                            item.isAdditionalCartEntry
                                        }
                                        deletePO={deletePO}
                                        winWidth={winWidth}
                                        onImagePreview={onImagePreview}
                                        myCaseResourceType={myCaseResourceType}
                                        vendorCaseErrorRedirection={
                                            vendorCaseErrorRedirection
                                        }
                                        onIsSerialUnknown={onIsSerialUnknown}
                                    />
                                </>
                            );
                        })}
                </>
            ) : (
                <NoItemTableData
                    padding="14px"
                    content={t('reportUsage.noUsageItemsMsg')}
                />
            )}
        </React.Fragment>
    );
};

export default ItemsListRPContainerDesktop;
